import { ReactNode, useEffect, useState } from "react";

import styles from "./VectorSettings.module.css";
import { RetrievalMode, VectorFieldOptions } from "../../api";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";

interface Props {
    showImageOptions?: boolean;
    updateRetrievalMode: (retrievalMode: RetrievalMode) => void;
    updateVectorFields: (options: VectorFieldOptions[]) => void;
}

export const VectorSettings = ({ updateRetrievalMode, updateVectorFields, showImageOptions }: Props) => {
    const [retrievalMode, setRetrievalMode] = useState<RetrievalMode>(RetrievalMode.Hybrid);
    const [vectorFieldOption, setVectorFieldOption] = useState<string>();

    useEffect(() => {
        showImageOptions
            ? updateVectorFields([VectorFieldOptions.Embedding, VectorFieldOptions.ImageEmbedding])
            : updateVectorFields([VectorFieldOptions.Embedding]);
    }, [showImageOptions]);

    function handleChange(event: SelectChangeEvent<any>, child: ReactNode): void {
        setRetrievalMode(event.target.value);
        updateRetrievalMode(event.target.value);
    }

    return (
        <Stack className={styles.container} spacing={2}>
            <FormControl required fullWidth>
                <InputLabel id="select-retrieval-mode">Retrieval Mode</InputLabel>
                <Select labelId="select-retrieval-mode" id="demo-simple-select" value={retrievalMode} label="Retrieval Mode" onChange={handleChange}>
                    <MenuItem value={RetrievalMode.Hybrid}>Vectors + Text (Hybrid)</MenuItem>
                    <MenuItem value={RetrievalMode.Vectors}>Vectors</MenuItem>
                    <MenuItem value={RetrievalMode.Text}>Text</MenuItem>
                </Select>
            </FormControl>
            {/* {showImageOptions && [RetrievalMode.Vectors, RetrievalMode.Hybrid].includes(retrievalMode) && (
                <ChoiceGroup
                    options={vectorFields}
                    onChange={onVectorFieldsChange}
                    selectedKey={vectorFieldOption}
                    defaultSelectedKey={VectorFieldOptions.Both}
                    label="Vector Fields (Multi-query vector search)"
                />
            )} */}
        </Stack>
    );
};
